import React from 'react';
import { Box, Tooltip, Typography } from '@material-ui/core';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import { unpackToDateTime } from '@campfire/hot-date';
import { CommonRequiringActionWidgetProps, getEndDateFromRange, getStartDateFromRange } from '../../../shared';
import { useCampfireQuery } from '../../../../../../../../../global/network/useCampfireQuery';
import { GET_TABLE_WIDGET_CANCELLED_ACTIVITIES } from './cancelled-rosters-table-widget-model.gql';
import {
  GetTableWidgetCancelledActivities,
  GetTableWidgetCancelledActivitiesVariables,
} from './__generated__/GetTableWidgetCancelledActivities';
import { useApplyCustomWords } from '../../../../useCustomWords';
import { WidgetTypes } from '../../../../dashboard-widget-setting/dashboard-widget-model';

export const CancelledRostersTableWidget = (props: CommonRequiringActionWidgetProps) => {
  const cw = useApplyCustomWords();
  const { filters, range } = props;
  const { programIds, activityIds } = JSON.parse(filters) as { programIds: [string]; activityIds: [string] };

  const { data, loading } = useCampfireQuery<
    GetTableWidgetCancelledActivities,
    GetTableWidgetCancelledActivitiesVariables
  >(GET_TABLE_WIDGET_CANCELLED_ACTIVITIES, {
    options: {
      variables: {
        programIds: programIds.length > 0 ? programIds : null,
        activityIds: activityIds.length > 0 ? activityIds : null,
        range: range,
        widgetType: WidgetTypes.TABLE,
        startDate: range ? getStartDateFromRange(range) : null,
        endDate: range ? getEndDateFromRange(range) : null,
      },
    },
  });

  const cancelledActivities =
    data?.vm.cancelledActivities.map((cancelledActivity) => ({
      id: cancelledActivity.cancelledActivityId,
      activityName: cancelledActivity.activity.name,
      program: cancelledActivity.activity.program.name,
      activityDate: unpackToDateTime(cancelledActivity.activityDate).toFormat('dd/MM/y'),
      cancelledDate: unpackToDateTime(cancelledActivity.cancelledDate).toFormat('dd/MM/y'),
      cancelledBy: cancelledActivity.cancelledBy
        ? `${cancelledActivity.cancelledBy.preferredName} ${cancelledActivity.cancelledBy.lastName}`
        : null,
    })) || [];

  const columns: GridColumns = [
    {
      field: 'activityName',
      headerName: cw('Activity'),
      flex: 1,
      minWidth: 150,
      disableColumnMenu: true,
      renderCell: ({ row }: any) => {
        return (
          <Tooltip title={row.activityName}>
            <Typography noWrap style={{ fontSize: 'inherit' }}>
              {row.activityName}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'program',
      headerName: cw('Program'),
      flex: 1,
      minWidth: 150,
      disableColumnMenu: true,
      renderCell: ({ row }: any) => {
        return (
          <Tooltip title={row.program}>
            <Typography noWrap style={{ fontSize: 'inherit' }}>
              {row.program}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'activityDate',
      headerName: cw('Activity Date'),
      flex: 1,
      minWidth: 180,
      disableColumnMenu: true,
    },
    {
      field: 'cancelledDate',
      headerName: 'Cancelled Date',
      flex: 1,
      minWidth: 180,
      disableColumnMenu: true,
    },
    {
      field: 'cancelledBy',
      headerName: 'Cancelled By',
      flex: 1,
      minWidth: 180,
      disableColumnMenu: true,
      renderCell: ({ row }: any) => {
        return (
          <Tooltip title={row.cancelledBy}>
            <Typography noWrap style={{ fontSize: 'inherit' }}>
              {row.cancelledBy}
            </Typography>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box width='100%' height='100%'>
      <DataGrid columns={columns} rows={cancelledActivities} loading={loading} autoPageSize disableSelectionOnClick />
    </Box>
  );
};
